import type { IPropertyBag } from '@deity-io/di-data-basics';
import React from 'react';

export enum UIActionTypes {
  MODEL_IS_MODIFIED = 'MODEL_IS_MODIFIED',
  SET_PANEL_TOP = 'SET_PANEL_TOP',
  SET_CURRENT_ENVIRONMENT = 'SET_CURRENT_ENVIRONMENT',
  CLEAR_CURRENT_ENVIRONMENT = 'CLEAR_CURRENT_ENVIRONMENT'
}
export interface IModelIsUpdated {
  type: UIActionTypes.MODEL_IS_MODIFIED;
  payload: boolean;
}

export interface ISetPanelTop {
  type: UIActionTypes.SET_PANEL_TOP;
  payload: number;
}

export type IRuntimeEnvironment = { uuid: string; name: string; description: string; variables: IPropertyBag };

export interface ISetCurrentEnvironment {
  type: UIActionTypes.SET_CURRENT_ENVIRONMENT;
  payload: IRuntimeEnvironment | undefined;
}

export interface IClearCurrentEnvironment {
  type: UIActionTypes.CLEAR_CURRENT_ENVIRONMENT;
}

export type UIActions = IModelIsUpdated | ISetPanelTop | ISetCurrentEnvironment | IClearCurrentEnvironment;

export interface IUIState {
  modelIsUpdated: boolean;
  apiIsUpdated: boolean;
  modelIsModified: boolean;
  flowIsUpdated: boolean;
  panelTop: number;
  currentEnvironment?: IRuntimeEnvironment;
}
export interface UIContextInterface {
  state: IUIState;
  dispatch: (UIAction: UIActions) => void;
}
export const UIContext = React.createContext<UIContextInterface | null>(null);
